import React from 'react';

const ComponentSubcategoryList = ({
  subcategories,
  filters,
  onFilterChange,
  onEdit,
  onDelete,
  categories
}) => (
  <table>
    <thead>
      <tr>
        <th>
          Subcategory Name
          <br />
          <input
            type="text"
            value={filters.subcategory_name}
            onChange={e => onFilterChange('subcategory_name', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Description
          <br />
          <input
            type="text"
            value={filters.subcategory_description}
            onChange={e => onFilterChange('subcategory_description', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Category
          <br />
          <select
            value={filters.component_category_id}
            onChange={e => onFilterChange('component_category_id', e.target.value)}
          >
            <option value="">All</option>
            {categories.map(cat => (
              <option key={cat.component_category_id} value={cat.component_category_id}>
                {cat.category_name}
              </option>
            ))}
          </select>
        </th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {subcategories.map(subcat => (
        <tr key={subcat.component_subcategory_id}>
          <td>{subcat.subcategory_name}</td>
          <td>{subcat.subcategory_description}</td>
          <td>{subcat.category_name}</td>
          <td>
            <button onClick={() => onEdit(subcat)}>Edit</button>
            <button 
              onClick={() => onDelete(subcat.component_subcategory_id)}
              style={{ 
                marginLeft: 8, 
                backgroundColor: '#dc3545', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                padding: '0.25rem 0.5rem', 
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
            >
              Delete
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ComponentSubcategoryList;